import { required } from './shared';
import type { NopeContext, NopeValidator, ObjectErrors, ObjectShape, ValidationResult, ValidationRule } from './shared';

class NopeObject {
  validationRules: ValidationRule[] = [];
  objectShape?: ObjectShape;

  shape(shape: ObjectShape): this {
    this.objectShape = shape;

    return this;
  }

  required(message = 'This field is required'): this {
    this.validationRules.push(required(message));

    return this;
  }

  validate(entry: NopeContext): ValidationResult {
    if (this.validationRules.length > 0) {
      for (const fn of this.validationRules) {
        const error = fn(entry);

        if (error) {
          // Object-level rule failure (e.g. `.required()`). When this validator
          // is nested under another shape, the parent stores the message string
          // directly, so we preserve the original (string) return value.
          return error;
        }
      }
    }

    if (!this.objectShape) {
      return undefined;
    }

    const errors: ObjectErrors = {};

    for (const [key, value] of Object.entries(entry)) {
      const validator: NopeValidator | undefined = this.objectShape[key];

      const res = validator?.validate(value, entry, this.objectShape);

      if (res) {
        errors[key] = res as string;
      }
    }

    return errors;
  }
}

export default NopeObject;
